import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import API_BASE_URL from "./apiBase";

const DEFAULT_TITLE = "Green Circle Environment";
const DEFAULT_DESCRIPTION =
  "Green Circle Environment provides waste management and environmental services.";

function setMetaTag(name, content, attribute = "name") {
  if (content === null || content === undefined) return;

  let tag = document.head.querySelector(`meta[${attribute}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function useSeoMetadata() {
  const location = useLocation();

  useEffect(() => {
    const controller = new AbortController();
    const pagePath = location.pathname || "/";

    document.title = DEFAULT_TITLE;
    setMetaTag("description", DEFAULT_DESCRIPTION);

    fetch(`${API_BASE_URL}/get_seo.php?page_path=${encodeURIComponent(pagePath)}`, {
      signal: controller.signal,
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.success || !data.seo) return;

        const { meta_title, meta_description, meta_keywords } = data.seo;
        const title = meta_title || DEFAULT_TITLE;
        const description = meta_description || DEFAULT_DESCRIPTION;

        document.title = title;
        setMetaTag("description", description);
        setMetaTag("keywords", meta_keywords || "");
        setMetaTag("og:title", title, "property");
        setMetaTag("og:description", description, "property");
        setMetaTag("twitter:title", title);
        setMetaTag("twitter:description", description);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("SEO metadata error:", err);
        }
      });

    return () => controller.abort();
  }, [location.pathname]);
}
